import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, Loader2, AlertCircle, Crown } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    let stopped = false;

    const poll = async () => {
      attempts++;
      if (attempts > 12) { setStatus("timeout"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setDetails(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        setTimeout(() => { if (!stopped) poll(); }, 2500);
      } catch (e) {
        setStatus("error");
      }
    };
    poll();
    return () => { stopped = true; };
  }, [sessionId]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-20">
      <div className="gold-border-gradient p-10 text-center">
        {status === "paid" ? (
          <>
            <Crown className="w-12 h-12 text-gold mx-auto" />
            <h1 className="mt-4 font-heading text-4xl tracking-tighter">Paiement <span className="gold-text">réussi</span></h1>
            <p className="mt-3 text-white/70">Merci ! Vos crédits ont été ajoutés à votre compte XookPub.</p>
            {details && <p className="mt-2 text-sm text-white/50">{(details.amount_total / 100).toFixed(2)} {details.currency?.toUpperCase()} encaissés</p>}
            <Link to="/dashboard" data-testid="success-cta" className="gold-btn mt-8 inline-flex">Retour au studio</Link>
          </>
        ) : status === "polling" ? (
          <>
            <Loader2 className="w-10 h-10 text-gold mx-auto animate-spin" />
            <h1 className="mt-4 font-heading text-3xl">Vérification du paiement...</h1>
            <p className="mt-2 text-white/60 text-sm">Quelques secondes seulement.</p>
          </>
        ) : (
          <>
            <AlertCircle className="w-10 h-10 text-red-400 mx-auto" />
            <h1 className="mt-4 font-heading text-3xl">Paiement non confirmé</h1>
            <p className="mt-2 text-white/60 text-sm">Le statut est {status}. Si le débit a eu lieu, contactez-nous.</p>
            <Link to="/pricing" className="ghost-btn mt-6 inline-flex">Retour aux tarifs</Link>
          </>
        )}
      </div>
    </div>
  );
}
